import React from "react";
import "./FullWidthBannerImage.scss";
import { withDefaults } from "../../utils/withDefaults";

export interface FullWidthBannerImageProps {
  backgroundImage?: string;
  bannerText?: string;
  children?: React.ReactNode;
}

export default function FullWidthBannerImage(incomingProps: FullWidthBannerImageProps) {
  const props = withDefaults(incomingProps, fullWidthBannerImageDefaultProps);

  return (
    <div
      className="full-width-banner"
      style={{ background: `url(${props.backgroundImage})` }}
    >
      {props.bannerText ? (
        <h1 className="banner-text">{props.bannerText}</h1>
      ) : null}
      {props.children}
    </div>
  );
}

const fullWidthBannerImageDefaultProps = {
  backgroundImage: "",
  bannerText: ""
};
